export interface ILang {
  nativeName: string,
  abbr: string,
  displayedAbbr: string
};

export const langs: Array<ILang>= [
  {
      abbr: 'en',
      nativeName: 'English',
      displayedAbbr: 'Eng',
  },
  {
      abbr: 'ar',
      nativeName: 'Arabic',
      displayedAbbr: 'Ar',
  },
];
